import Chart from "./Chart";
import CONFIG from "../../../config";
export const config = {
  name: "basicStripChart",
  archive: "图表",
  domain: "条形图",
  alias: "基础条形图",
  thumb: CONFIG.ASSET_BASE_URL + "/charts/basicStripChart.png",
};
export const option = () => ({
  dataset: {
    source: [
      ["系列", "系列1"],
      ["名称2", 43.3],
      ["名称3", 83.1],
      ["名称4", 86.4],
      ["名称5", 72.4],
    ],
  },
  title: {
    text: "基础条形图",
  },
  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "shadow",
    },
  },
  xAxis: {
    type: "value",
  },
  //   ------   y轴  ----------
  yAxis: {
    type: "category",
  },
  label: {
    show: false,
    position: "top",
    color: "rgba(255,255,255,0.8)",
  },
  series: [
    {
      type: "bar", // 类型
    },
  ],
});
export default (props) => {
  return <Chart defaultOption={option()} {...props} />;
};
